import type { VariantProps } from 'class-variance-authority'

import { cva } from 'class-variance-authority'

export { default as Button } from './Button.vue'

// Button variants mapped to spatius-site-1 login-page button system
// (btn-deep / btn-light / SSO / tertiary link). All pill-shaped.
export const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full font-inter transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:pointer-events-none disabled:cursor-not-allowed [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0',
  {
    variants: {
      variant: {
        // .btn-deep — primary CTA, ink-navy always; hover = slight opacity; disabled = solid accent bg (keeps internal text contrast readable).
        default: 'bg-[#151131] text-[#eeebe4] font-bold hover:opacity-90 disabled:bg-[#9a9ac0] disabled:text-[#eeebe4]',
        // Destructive — VIS replaces red with warn amber
        destructive: 'bg-[rgba(231,197,107,0.25)] text-[#8a6a1e] font-semibold hover:bg-[rgba(231,197,107,0.4)] disabled:opacity-40',
        // SSO / Secondary outline — white + hairline, hover accent border + accent-subtle bg
        outline: 'bg-white border border-[#eeebe4] text-[#2b2623] font-semibold hover:border-[#9a9ac0] hover:bg-[#dfe6ff] hover:text-[#9a9ac0] disabled:opacity-40',
        // .btn-light — white pill → accent-subtle bg on hover
        secondary: 'bg-white text-[#2b2623] font-bold hover:bg-[#dfe6ff] disabled:opacity-40',
        // Tertiary — flat accent text, no hover change
        ghost: 'text-[#9a9ac0] font-semibold disabled:opacity-40',
        // Link — accent text, underline on hover
        link: 'text-[#9a9ac0] font-semibold underline-offset-4 hover:underline disabled:opacity-40',
      },
      size: {
        default: 'h-10 px-5 text-[14px]',
        xs: 'h-7 px-3 text-[12px]',
        sm: 'h-9 px-4 text-[13px]',
        lg: 'h-12 px-7 text-[16px]',
        icon: 'h-10 w-10 p-0',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
)

export type ButtonVariants = VariantProps<typeof buttonVariants>
